import React, { useEffect, useState } from 'react';
import { Col, Row } from 'react-bootstrap';

import { Select, Condicao, Finalizadora } from '~/pages/EntradaNFE/protocols';

import { useEntradaNFE } from '~/pages/EntradaNFE/EntradaNFEContext';
import { formatCurrencyAsText, transformAsCurrency } from '~/utils/functions';
import { InputMoney, InputSelect } from '~/components/NovosInputs';
import api from '~/services/api';

export type SelectType = {
  value: number | string;
  label: string;
};

export const FormFinanceiro: React.FC = () => {
  const { formParcela, canUpdate, parcelas, loja, perfil } = useEntradaNFE();
  const [total, setTotal] = useState(0);
  const [categorias, setCategorias] = useState<SelectType[]>([]);
  const [contas, setContas] = useState<SelectType[]>([]);

  const { register, control, setValue, formState, clearErrors } = formParcela;

  useEffect(() => {
    let totalParcelas = 0;
    parcelas.map((parcela: any) => {
      totalParcelas += transformAsCurrency(parcela.val_parcela);
      return parcela;
    });
    setTotal(totalParcelas);
  }, [parcelas]);

  // Categorias
  useEffect(() => {
    (async () => {
      if (perfil) {
        const tipo_categoria = perfil.tipo_operacao === 1 ? 0 : 1;
        const { data } = await api.get(
          `/perfil-loja/categorias/${tipo_categoria}`,
        );
        const option = data.data.map((categoria: any) => {
          return {
            value: categoria.cod_categoria,
            label: categoria.descricao,
            ...categoria,
          };
        });

        setCategorias(option);
      }
    })();
  }, [perfil]);

  // Contas
  useEffect(() => {
    (async () => {
      if (loja?.cod_loja) {
        const { data } = await api.get(`/contas/loja/${loja?.cod_loja}`);
        const option = data.data.map((conta: any) => {
          return {
            value: conta.cod_cc,
            label: conta.descricao,
            ...conta,
          };
        });

        setContas(option);
      }
    })();
  }, [loja?.cod_loja]);

  return (
    <>
      <Row className="d-flex align-items-end">
        <Col sm={12} md={2}>
          <InputSelect
            ListaWidth="580px"
            label="Categoria"
            placeholder="Selecione..."
            name="categoria"
            register={register}
            disabled={!canUpdate}
            isError={!!formState.errors.categoria}
            control={control}
            options={categorias}
            changeSelected={(selected) => {
              clearErrors('categoria');
              setValue('categoria', selected);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputSelect
            ListaWidth="480px"
            label="Conta"
            placeholder="Selecione..."
            name="conta"
            register={register}
            disabled={!canUpdate}
            isError={!!formState.errors.conta}
            control={control}
            options={contas}
            changeSelected={(selected) => {
              clearErrors('conta');
              setValue('conta', selected);
            }}
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            label="Desconto"
            placeholder="0,00"
            min={0}
            decimals={2}
            name="val_desc_financeiro"
            register={register}
            disabled={!canUpdate}
            isError={false}
            showIcon
          />
        </Col>
        <Col sm={12} md={2}>
          <InputMoney
            label="Encargos"
            placeholder="0,00"
            min={0}
            decimals={2}
            name="val_enc_financeiro"
            register={register}
            disabled={!canUpdate}
            isError={false}
            showIcon
          />
        </Col>
        <Col sm={12} md={4}>
          <h5
            style={{
              textAlign: 'right',
              display: 'block',
              marginTop: '20px',
            }}
          >
            {`Total Financeiro: R$${formatCurrencyAsText(total)}`}
          </h5>
        </Col>
      </Row>
    </>
  );
};
